export default  [
  {
		path: "list",
		component: () => import("@/views/ximei/xiMeiContract/list.vue"),
		meta:{title:'洗美管理',keepAlive:true},
	},
]